import { render, staticRenderFns } from "./SentenciasPanel.vue?vue&type=template&id=f81071b4"
import script from "./SentenciasPanel.vue?vue&type=script&lang=js"
export * from "./SentenciasPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports